import script from "./ModalIdle.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalIdle.vue?vue&type=script&setup=true&lang=js"

import "./ModalIdle.vue?vue&type=style&index=0&id=b29a2e42&lang=css"

const __exports__ = script;

export default __exports__